import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./user/state";
import searchReducer from "./search/state";
import mapReducer from "./map/state";
import galleryReducer from "./gallery/state";
import reviewReducer from "./review/state";
import sharePositionReducer from "./share-position/state";
import detailReducer from "./detail/state";
import ribbonReducer from "./ribbon/state";
import reportReducer from "./report/state";
import mymapsReducer from "./mymaps/state";

const reducer = combineReducers({
	user: userReducer,
	search: searchReducer,
	map: mapReducer,
	reviewPopupState: reviewReducer,
	sharePosition: sharePositionReducer,
	detail: detailReducer,
	gallery: galleryReducer,
	ribbon: ribbonReducer,
	report: reportReducer,
	mymaps: mymapsReducer,
});

export type IState = ReturnType<typeof reducer>;

// nahodime Redux store
export const store = configureStore({
	reducer,
});

export type IStore = typeof store;
export type IDispatch = typeof store.dispatch;
